var exports = {
  "P": "xa15a2ab7--75085c--label",
};

module.exports = exports;
